import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import type { ForWho } from "@/features/transcripts/types";

interface TaxpayerSpouseToggleProps {
  value: ForWho;
  onValueChange: (value: ForWho) => void;
}

export function TaxpayerSpouseToggle({ value, onValueChange }: TaxpayerSpouseToggleProps) {
  return (
    <ToggleGroup
      type="single"
      value={value}
      onValueChange={(v) => {
        if (v) onValueChange(v as ForWho);
      }}
      className="bg-muted gap-1 rounded-lg p-1"
    >
      <ToggleGroupItem value="T" className="data-[state=on]:bg-primary data-[state=on]:text-primary-foreground px-4">
        Taxpayer
      </ToggleGroupItem>
      <ToggleGroupItem value="S" className="data-[state=on]:bg-primary data-[state=on]:text-primary-foreground px-4">
        Spouse
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
